import React, { FC } from "react";
import { DrawerProps } from "@material-ui/core/Drawer";
import { StyledMuiDrawer } from './styles';

const Drawer: FC<DrawerProps> = (props) => {
  return (
    <StyledMuiDrawer {...props} />
  );
};

export default Drawer;
